/**
 * True if `x` is not `null` or `undefined`.
 * Can be used as a type predicate filter:
 *
 * @example isNonNullable(Maybe<string>) // string
 * @example Maybe<string>[].filter(isNonNullable) // string[]
 */
export const isNonNullable = <T>(x: T): x is NonNullable<T> => x !== null && x !== undefined
